import { courseId } from './constants';
import axios from 'modules/api-client/request';

import type { ICourse } from './types';

export const getCourseById = () => axios.get<void, ICourse>(`/courses/${courseId}`);
